import { Controller } from '@hotwired/stimulus';
import { getPreviewUrl } from 'manage/utils/getPreviewUrl';

export default class extends Controller {
  static targets = ['empty', 'preview'];

  // action="change->file-field-validator#validate change->image-preview#update"
  // validator がサイズ超過で消したファイルを出さないよう、validator のあとに並べる
  update({ target }) {
    const file = target.files[0];
    if (!file) return;

    getPreviewUrl(file, (url) => {
      this.previewTarget.src = url;
      this.previewTarget.hidden = false;
      this.emptyTarget.hidden = true;
    });
  }
}
